import { useState, useEffect } from 'react';

export default function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('cookie-consent', 'all');
    setShowBanner(false);
  };

  const acceptNecessary = () => {
    localStorage.setItem('cookie-consent', 'necessary');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white border-t-2 border-azure-200 shadow-2xl animate-slide-up">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex items-start gap-4 flex-1">
            <div className="w-12 h-12 flex items-center justify-center bg-azure-100 rounded-lg flex-shrink-0">
              <i className="ri-cookie-line text-azure-600 text-2xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                Utilizzo dei Cookie
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                Utilizziamo cookie tecnici necessari per il funzionamento del sito e cookie analitici per migliorare la tua esperienza. 
                Puoi scegliere quali cookie accettare. Per maggiori informazioni consulta la nostra{' '}
                <a href="/cookie-policy" className="text-azure-600 hover:text-azure-700 underline font-medium">
                  Cookie Policy
                </a>.
              </p>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
            <button
              onClick={acceptNecessary}
              className="px-6 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm"
            >
              Solo Necessari
            </button>
            <button
              onClick={acceptAll}
              className="px-6 py-3 bg-azure-600 hover:bg-azure-700 text-white font-semibold rounded-lg transition-colors whitespace-nowrap cursor-pointer text-sm shadow-md"
            >
              Accetta Tutti
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
